const coursetypes = {
	title: "Kompetanse",
	new_coursetype: "Ny kompetanse",
	edit_coursetype: "Rediger kompetanse: {name}",
	view_coursetype: "Vis kompetanse: {name}",
	list_title: "Kompetanse liste",
	list_subtitle: "Håndtere kompetanse",
	create_title: "Opprett kompetanse",
	update_title: "Endre kompetanse",
	details_title: "Kompetanse detaljer",
	id: "ID",
	name: "Navn",
	category: "Kategori",
	status: "Status",
	code: "Kode",
	teaching_plan: "Opplæringsplan",
	teaching_material: "Opplæringsmateriell",
};
export default coursetypes;